import { DataFormatterType } from '../DataFormatterType';
import { DataFormatterOptions } from '../DataFormatterType';
import { DataTools } from '../../utils/DataTools';
import { Localizer } from '../../localize/localizer';

/**
 * Data formatter for general text types
 * @ignore
 */
export class DataFormatBoolean extends DataFormatterType {
    getName(): string {
        return 'boolean';
    }

    /* Return option text to the right of the display value */
    getUnitText(options?: DataFormatterOptions): string {
        return '';
    }

    /* Default options for the number formatter */
    initializeOptions(): DataFormatterOptions {
        return {};
    }

    /*
    Format data as a number.
    Options can have format='<numeral js template>'
    */
    format(data: any, options: any) {
        if (data === null) {
            return '';
        }

        if (data === '') {
            return '';
        }

        if (typeof data === 'string') {
            if (data.toLocaleLowerCase() === 'yes') return 'Yes';

            if (data.toLocaleLowerCase() === 'true') return 'Yes';

            if (data.toLocaleLowerCase() === 'y') return 'Yes';

            if (data.toLocaleLowerCase() === 'no') return 'No';

            if (data.toLocaleLowerCase() === 'false') return 'No';

            if (data.toLocaleLowerCase() === 'n') return 'No';
        }

        if (data === null || data === 0 || data === false || data === 'false' || data === '0') {
            return 'No';
        }

        return 'Yes';
    }

    /*
    Format the data for export.  As this is a basic type, we want CSV files
    to have the raw number value.
    */
    formatExport(data: any, options?: DataFormatterOptions, refObj?: any): any {
        return this.format(data, options);
    }

    //
    // funtion to unformat the currently formatted data
    //
    // @param [Object] data data to be unformatted
    // @param [String] path path where the value is being edited
    // @return [Object] data unformatted data
    //
    unformat(data: any, path: any): boolean | undefined {
        if (data == null) {
            return undefined;
        }

        if (typeof data === 'string' && data === '') {
            return undefined;
        }

        if (typeof data === 'boolean') {
            return data;
        }

        if (data === '0') {
            return false;
        }

        if (data === '1') {
            return true;
        }

        if (data === 'Y' || data === 'Yes' || data === 'y' || data === 'yes') {
            return true;
        }

        if (data === 'N' || data === 'No' || data === 'n' || data === 'no') {
            return false;
        }

        if (data === 'T' || data === 'True' || data === 't' || data === 'true') {
            return true;
        }

        if (data === 'F' || data === 'False' || data === 'f' || data === 'false') {
            return false;
        }

        if (typeof data === 'number' && data >= 1) {
            return true;
        }

        if (typeof data === 'number' && data === 0) {
            return false;
        }

        if (typeof data === 'boolean') {
            if (data) {
                return true;
            }
            return false;
        }

        if (data === null || data === 0) {
            return false;
        }

        if (data === 'No' || data === 'no' || data === 'false' || data === 'off') {
            return false;
        }

        return true;
    }

    getAlign(): string {
        return 'center';
    }
}

export default DataFormatBoolean;
